import { get } from "../../service/api";

const GetMerchantVatOut = async (merchantId, queryString) => {
  try {
    const response = await get(
      `/merchant/${merchantId}/merchantVatOut?1=1${queryString}`
    );
    return response;
  } catch (error) {
    console.error("Error GetMerchantVatOut:", error);
    throw error;
  }
};

export default GetMerchantVatOut;
